import React from "react";
import { Link } from "react-router-dom";
import * as style from "../styles.module.scss";
import {
  EmergencyContactName,
  EmergencyContactTelephone,
} from "../../BasicInfo";

const EmergencyContact = ({
  state,
  errors,
  handleState,
  handleSubmit,
  navigateBackPath,
}) => {
  const isTelephoneInvalid =
    errors.emergencyContactTelephone &&
    errors.emergencyContactTelephone?.length > 0;
  const isTelephoneInvalidFormat =
    isTelephoneInvalid &&
    errors.emergencyContactTelephone[0] ===
      "Emergency contact telephone must be valid";
  const telephoneValidationMessage =
    (isTelephoneInvalid &&
      isTelephoneInvalidFormat && [
        "Please enter a valid emergency contact’s phone number",
      ]) ||
    (isTelephoneInvalid &&
      !isTelephoneInvalidFormat && [
        "Please enter your emergency contact’s phone number",
      ]) ||
    [];

  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleSubmit}
    >
      <div>
        <EmergencyContactName
          name={state.emergencyContactName}
          validation={errors}
          handleChange={handleState}
          classes={"form-group"}
        />
        <EmergencyContactTelephone
          telephone={state.emergencyContactTelephone}
          validation={{ emergencyContactTelephone: telephoneValidationMessage }}
          handleChange={handleState}
          classes={"form-group"}
        />
      </div>
      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Link to={navigateBackPath}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <button className="btn btn-primary btn-block" type="submit">
          Next
        </button>
      </div>
    </form>
  );
};

export default EmergencyContact;
